import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api, { mediaUrl } from "../lib/api";
import { fmtDate } from "../lib/utils2";

export default function BlogPost() {
  const { id } = useParams();
  const [a, setA] = useState(null);
  useEffect(() => { api.get(`/articles/${id}`).then((r) => setA(r.data)); }, [id]);
  if (!a) return <div className="py-32 text-center text-slate-400">Caricamento...</div>;
  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <Link to="/blog" className="text-sm text-slate-500 hover:text-navy">← Torna al blog</Link>
      <div className="text-xs text-slate-400 mt-6 mb-3">{fmtDate(a.published_at)} • {a.author}</div>
      <h1 className="font-serif text-4xl font-bold text-navy leading-tight mb-6">{a.title}</h1>
      <img src={mediaUrl(a.cover_url)} alt="" className="w-full aspect-video object-cover rounded-2xl mb-8" />
      <p className="text-lg text-slate-700 leading-relaxed whitespace-pre-line">{a.body}</p>
    </article>
  );
}
